import { inject } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs';
import { selectIsKeepMenusOpen } from './debug.selectors';
import { MenuTriggerMonitorService } from './menu-trigger-monitor.service';

export const keepMenusOpen = createEffect(
  (store = inject(Store), menuTriggerMonitorService = inject(MenuTriggerMonitorService)) =>
    store
      .select(selectIsKeepMenusOpen)
      .pipe(
        tap((keepMenusOpen) =>
          keepMenusOpen
            ? menuTriggerMonitorService.startMonitoring()
            : menuTriggerMonitorService.stopMonitoring()
        )
      ),
  { functional: true, dispatch: false }
);
